$(function() {
	// Add custom input type that is able to properly edit
	// html escaped charachters, i.e.:
	// &lt;h1&gt;Test head 1&lt;/h1&gt;
	$.editable.addInputType('escapedhtml', {
		 element : function(settings, original) {
	        var textarea = $('<input type="text" />');
	        $(this).append(textarea);
	        return textarea;
	    },
	    content : function(string, settings, original) {
	    	$('input[type=text]', this).val($("<div/>").html(string).text());
	    }
	});

	// Edit in Place
	if ($.fn.editable) {
		var current_url = window.location.toString().replace(/\?.*/, '').replace(/#.*/, '');
		var update_url = current_url + '/update-project-details';

		// Project title
		$('.eip-project-name').editable( current_url + '/save-project-title', {
			type: "escapedhtml",
			indicator : 'Saving...',
			cancel : '<input type="button" class="button button-small" value="Cancel" />',
			submit : '<input type="button" class="button button-small button-primary" value="Save" />',
			tooltip   : 'Click to edit...',
			event: 'dblclick',
			onblur: function() { },
			onreset: function(){ $('a.edit-project-title').show();},
			callback: function(){ $('a.edit-project-title').show();},
			onedit: function(){
				$('a.edit-project-title').hide();
				$('.eip-hover').removeClass('eip-hover');
			},
			cssclass: 'eip-form',
			select: true
		});
		$('a.edit-project-title').click(function() {
			$('.eip-project-name').dblclick();
			return false;
		});

		var eip_settings = {
			type: "escapedhtml",
			indicator : 'Saving...',
			cancel : '<input type="button" class="button button-small" value="Cancel" />',
			submit : '<input type="button" class="button button-small bolded" value="Save" />',
			tooltip   : 'Click to edit...',
			event: 'dblclick',
			onblur: function(){},
			onreset: function(settings, el){ $(el).parents('p').find('a.edit-small').show(); },
			onsubmit: function(settings, el){ $(el).parents('p').find('a.edit-small').show(); },
			onedit: function(settings, el){
				$(el).parents('p').find('a.edit-small').hide();
				$('.eip-hover').removeClass('eip-hover');
			},
			cssclass: 'eip-details-form',
			select: true
		}


		// Num Pages
		$('.eip-num-pages').editable(update_url,
			$.extend({}, eip_settings, {
				'height': 20,
				'submitdata' : { 'field_name' : 'num_pages' },
				data: function(value, settings){
						return $(this).attr('data-num-pages');
				},
				callback: function( value, settings ){
					var num_pages = parseInt(value);
					var suffix = num_pages > 1 ? 's' : '';
					$(this).text( value + ' page' + suffix  ).attr('data-num-pages', value);
				}
			})
		);


		// Time frame
		$('.eip-timeframe').editable(update_url,
			$.extend({}, eip_settings, {
				'submitdata' : { 'field_name' : 'time_frame' },
				'type':'select',
				'data': "{1:'Expedited', 2:'Express', 5:'Standard'}"
			})
		);


		// ASAP
		$('.eip-asap').editable(update_url,
			$.extend({}, eip_settings, {
				'submitdata' : { 'field_name' : 'asap' },
				'type':'select',
				'data': "{0:'No', 1:'Yes'}",
				callback: function( value, settings ){
					var is_asap = value == 1;
					$(this).toggleClass('red', is_asap);
					$(this).text( is_asap ? 'Yes' : 'No' );
				}
			})
		);


		// Samples section
		$('.eip-samples-section').editable(update_url,
			$.extend({}, eip_settings, {
				'submitdata' : { 'field_name' : 'samples_section' },
				'type':'select',
				'data': "{'Yes':'Yes', 'No':'No'}"
			})
		);


		// Implementation options
		if( typeof(implementation_options) != 'undefined') {
			$('.eip-implement-as').editable(update_url,
				$.extend({}, eip_settings, {
					'submitdata' : { 'field_name' : 'implement_as'},
					'type':'select',
					'data': implementation_options,
					callback: function(v, el) {
						$(this).html( implementation_options[v] );
					}
				})
			);
		}


		// Attach the eip event to the edit link
		$('.comment-project-details .edit-small').click(function(){
			$(this).parent().find('.eip').trigger('dblclick');
			return false;
		});


		// editable charges
		var update_url_charges = '/charges/update';
		var eip_charges_settings = {
			indicator : 'Saving...',
			submit : '',
			event: 'dblclick',
			onblur: 'cancel',
			cssclass: 'eip-price-form',
			select: true
		}

		function number_format(num){
			num += '';
			x = num.split('.');
			x1 = x[0];
			x2 = x.length > 1 ? '.' + x[1] : '';
			var rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + ',' + '$2');
			}
			return x1 + x2;
		}

		// charges amount
		$('body').livequery('.eip-amount', function(){
			$(this).editable(update_url_charges,
				$.extend({}, eip_charges_settings, {
					width:50,
					submitdata : function(value, settings){
						var id = $(this).parents('tr').attr('data-id') || $(this).closest('.charge-small').attr('data-id');
						return { 'field_name' : 'amount', 'id': id }
					},
					data: function(value, settings){
						return $(this).attr('data-amount');
					},
					callback: function( value, settings ){
						$(this).text( '$' + number_format(value) ).attr('data-amount', value);
					}
				})
			);
		});


		// charges title
		$('body').livequery('.eip-charge-title', function(){
			$(this).editable(update_url_charges,
				$.extend({}, eip_charges_settings, {
					type: "escapedhtml",
					width:150,
					submitdata : function(value, settings){
						return {
							field_name: 'title',
							id: $(this).parents('tr').attr('data-id') || $(this).parents('.charge-small').attr('data-id'),
						};
					}
				})
			);
		});
	}


	// Delivery date - datepicker
	$('#project-delivery-date').datepicker({
		firstDay: 1,
		dateFormat: 'yy-mm-dd',
		onSelect: function(date, datepicker) {
			var handler = $('#delivery-date-handle');
			handler.html('Saving...');
			$.post(update_url,{
				'field_name' : 'delivery_date',
				'value': date
			}, function(v){
				handler.html(v);
			});
			return true;
		}
	});
	$('#project-delivery-date').parent().find('a, strong').click(function(){
		$('#project-delivery-date').focus();
		return false;
	});

	// Update Project Status

	$('.update-status select').on('change', function(event) {
		event.preventDefault();

		var $form = $(this).closest('form');
		var action = $form.attr('action');
		var data = $form.serializeArray();

		$form.addClass('is-submitting');

		$.ajax({
			type: 'POST',
			url: action,
			data: data,
			complete: function(res) {
				$form.removeClass('is-submitting');
			}
		});
	});

});
